<canvas class="chart-canvas" [id]="'monthly-debits-credits-chart' + index" height="400"> </canvas>
